/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CustomSigningRoles = {
    ActingAs: 'ActingAs',
    FinancialContributor: 'FinancialContributor'
} as const;
export type CustomSigningRoles = typeof CustomSigningRoles[keyof typeof CustomSigningRoles];


export function CustomSigningRolesFromJSON(json: any): CustomSigningRoles {
    return CustomSigningRolesFromJSONTyped(json, false);
}

export function CustomSigningRolesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomSigningRoles {
    return json as CustomSigningRoles;
}

export function CustomSigningRolesToJSON(value?: CustomSigningRoles | null): any {
    return value as any;
}

